<template>
  <div class="transaction-detail">
    <!-- 头部 -->
    <header>
      <div class="g-header">
        <div class="left" @click="changego">
          <van-icon name="arrow-left" color="#fff" size="20px" />
        </div>
        <div class="middle fs-18">交易记录</div>
        <div class="right"></div>
      </div>
    </header>



    <!-- 内容区域 -->
    <div class="content-area">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="--END--"
          @load="onLoad"
        >
          <!-- 空数据 -->
          <div class="empty-state" v-if="filteredList.length === 0">
            <img src="@/assets/image/czbg.png" class="empty-image" alt=""/>
            <p class="empty-tip">没有任何记录</p>
            <p class="empty-subtitle">和往常一样，这里什么都没</p>
          </div>
          
          <!-- 交易列表 -->
          <div class="transaction-list" v-else>
            <div 
              class="transaction-item" 
              v-for="(item, index) in filteredList" 
              :key="index"
            >
              <div class="item-left">
                <div class="transaction-type">{{ item.plan_name || '未知' }}</div>
                <div class="transaction-category">品类：{{ item.play_method || '未知' }}</div>
                <div class="transaction-time">订单：{{ item.issue || '未知' }}</div>
              </div>
              <div class="item-right">
                <div class="amount" :class="getMatchStatusClass(item)">
                  {{ getMatchStatusText(item) }}
                </div>
                <div class="reward">变现：{{ item.profit || '0' }}</div>
                <div class="points">积分: {{ item.quantity }}</div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import time from "@/utils/time";
import userApi from "@/api/user";

export default {
  name: "jiaoyijilu",
  data() {
    return {
      activeTab: 'all', // 当前选中的标签
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      transactionData: [], // 从API获取的交易数据
      // 模拟数据，实际应该从API获取
      mockData: [
        {
          type: '奖励',
          createtime: 1698062413,
          amount: 284.00,
          points: 100000,
          category: 'income'
        },
        {
          type: '奖励',
          createtime: 1698062413,
          amount: 246.00,
          points: 99716,
          category: 'income'
        },
        {
          type: '奖励',
          createtime: 1698062412,
          amount: 246.00,
          points: 99470,
          category: 'income'
        },
        {
          type: '奖励',
          createtime: 1698062406,
          amount: 246.00,
          points: 99224,
          category: 'income'
        },
        {
          type: '交易',
          createtime: 1698059937,
          amount: -123.00,
          points: 98978,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059933,
          amount: -142.00,
          points: 99101,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059933,
          amount: -142.00,
          points: 99243,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059919,
          amount: -123.00,
          points: 99385,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059919,
          amount: -123.00,
          points: 99508,
          category: 'expense'
        },
        {
          type: '交易',
          createtime: 1698059919,
          amount: -123.00,
          points: 99631,
          category: 'expense'
        }
      ]
    };
  },
  computed: {
    filteredList() {
      if (this.activeTab === 'all') {
        return this.transactionData;
      } else if (this.activeTab === 'income') {
        return this.transactionData.filter(item => item.category === 'income');
      } else if (this.activeTab === 'expense') {
        return this.transactionData.filter(item => item.category === 'expense');
      }
      return [];
    }
  },
  methods: {
    timeStr(timestamp) {
      return time.formatDatethree(timestamp * 1000);
    },
    async BtnOk() {
      this.$toast.loading({
        message: '加载中',
        duration: 0,
        forbidClick: true,
      });
      
      try {
        // 获取当前日期和30天前的日期
        const endDate = new Date();
        const beginDate = new Date();
        beginDate.setDate(beginDate.getDate() - 30);
        
        const beginDateStr = this.formatDate(beginDate);
        const endDateStr = this.formatDate(endDate);
        
        // 调用真实API
        const response = await userApi.jiaoyijilu(beginDateStr, endDateStr);
        
        if (response.code === 1) {
          // 处理返回的数据，转换为前端需要的格式
          this.transactionData = this.processTransactionData(response.data);
          this.list = this.transactionData;
        } else {
          this.$toast.fail(response.msg || '获取数据失败');
        }
        
        this.loading = false;
        this.finished = true;
        this.$toast.clear();
      } catch (error) {
        console.error('获取交易数据失败:', error);
        this.$toast.fail('网络错误，请稍后重试');
        this.loading = false;
        this.$toast.clear();
      }
    },
    onRefresh() {
      this.refreshing = false;
      this.finished = false;
      this.loading = true;
      this.BtnOk();
    },
    changego() {
      this.$router.go(-1);
    },
    // 切换标签
    switchTab(tab) {
      this.activeTab = tab;
      // 重新加载数据
      this.onRefresh();
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.BtnOk();
      }
    },
    changeDetail(item) {
      this.$router.push({
        path: "/betDetail",
        query: { item: JSON.stringify(item) },
      });
    },
    // 格式化日期为 YYYY-MM-DD 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 处理API返回的交易数据，转换为前端需要的格式
    processTransactionData(data) {
      return data.map(item => {
        // 根据新的接口结构处理数据
        // 新接口返回: issue, plan_name, play_method, profit, status, quantity
        
        // 映射play_method数字到中文
        const playMethodMap = {
          '1': '做高',
          '2': '做低', 
          '3': '做多',
          '4': '做空'
        };
        
        return {
          id: item.id || item.issue, // 使用issue作为id
          type: '交易', // 默认类型为交易
          plan_name: item.plan_name || '未知', // 计划名称
          play_method: playMethodMap[item.play_method] || item.play_method || '未知', // 玩法方法映射
          issue: item.issue || '未知', // 订单号
          createtime: item.createtime || Math.floor(Date.now() / 1000), // 创建时间，如果没有则使用当前时间
          amount: parseFloat(item.quantity) || 0, // 交易金额
          points: parseFloat(item.quantity) || 0, // 积分显示为交易金额
          quantity: item.quantity || '0', // 数量
          category: 'expense', // 默认为支出
          profit: item.profit || '0.00', // 利润
          status: parseInt(item.status), // 状态数值 (0=匹配中, 1=已匹配, 2=未匹配)
          original: item // 保留原始数据
        };
      });
    },
    getMatchStatusText(item) {
      // 根据新的status值判断显示文本
      // status=0匹配中，status=1已匹配，status=2未匹配
      if (item.status === 0) {
        return '匹配中';
      } else if (item.status === 1) {
        return '已匹配';
      } else if (item.status === 2) {
        return '未匹配';
      }
      return '未知';
    },
    getMatchStatusClass(item) {
      // 根据新的status值判断样式类
      // status=0匹配中，status=1已匹配，status=2未匹配
      if (item.status === 0) {
        return 'matching'; // 匹配中
      } else if (item.status === 1) {
        return 'matched'; // 已匹配
      } else if (item.status === 2) {
        return 'unmatched'; // 未匹配
      }
      return 'unknown'; // 未知
    },
  },
  mounted() {
    this.onRefresh();
  },
};
</script>

<style lang="less" scoped>
.transaction-detail {
  background: #050925;
  height: 100vh;
  color: #fff;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.g-header {
  background: #161936;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  flex-shrink: 0;
  position: relative;
  z-index: 20;
}

.left {
  // width: 44px;
  // height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.middle {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
}

.right {
  width: 44px;
}

.tab-bar {
  display: flex;
  background: #050925;
  /* border-bottom: 1px solid #2a3a5c; */
  flex-shrink: 0;
  position: relative;
  z-index: 10;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 16px 0;
  font-size: 16px;
  color: #8a9bb8;
  position: relative;
  cursor: pointer;
  
  &.active {
    color: #d4d5ea;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: #fff;
    }
  }
}

.content-area {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;
  background: #050925;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-image {
  width: 58%;
  display: block;
  margin: 0 auto 20px auto;
}

.empty-tip {
  font-size: 18px;
  color: #9c9497;
  // margin-bottom: 10px;
}

.empty-subtitle {
  font-size: 14px;
  color: #9c9497;
  margin: 0;
}

.transaction-list {
  /* padding-top: 16px; */
}

.transaction-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.item-left {
  flex: 1;
}

.transaction-type {
  font-size: 18px;
  color: #fff;
  margin-bottom: 10px;
  text-align: left;
}

.transaction-category {
  font-size: 17px;
  color: #9c9497;
  text-align: left;
  margin-bottom: 5px;
}

.transaction-time {
  font-size: 17px;
  color: #9c9497;
  text-align: left;
}

.item-right {
  text-align: right;
}

.amount {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
  padding: 2px 2px;
  border-radius: 4px;
  display: inline-block;
  
  &.positive {
    color: #aa3136;
  }
  
  &.negative {
    color: #3c7143;
  }
  
  &.matching {
    color: #49937a; // 匹配中 - 使用指定颜色
    border: 1px solid #49937a; // 2px边框
  }
  
  &.matched {
    color: #e65177; // 已匹配 - 使用指定颜色
    border: 1px solid #e65177; // 2px边框
  }
  
  &.unmatched {
    color: #49937a; // 未匹配 - 使用指定颜色
    border: 1px solid #49937a; // 2px边框
  }
  
  &.unknown {
    color: #9c9497; // 未知 - 灰色
  }
}

.reward {
  font-size: 17px;
  color: #9c9497;
  margin-bottom: 5px;
}

.points {
  font-size: 17px;
  color: #9c9497;
}

// 覆盖vant组件样式
:deep(.van-pull-refresh) {
  background: transparent;
  height: auto;
  overflow: visible;
}

:deep(.van-list) {
  background: transparent;
  height: auto;
  overflow: visible;
}

:deep(.van-loading) {
  color: #fff;
}

:deep(.van-list__finished-text) {
  color: #8a9bb8;
}
</style>